/**
 * KnowledgeBase Utils - Utility functions
 * 
 * PROJECT_RULES.md Compliance:
 * - ✅ TypeScript: Fully typed
 */

import { CATEGORY_COLORS, DEFAULT_COLOR } from './constants';

export const getAccentColor = (category: string): string => {
  return CATEGORY_COLORS[category] || DEFAULT_COLOR;
};